import useSubmissionRetries from '../../Hooks/useSubmissionRetries/useSubmissionRetries';

/* Performance Impact:
 * The benefit of this wrapper component is to shield <Form /> and its other child
 * components from unnecessary re-runs whenever this self-managed component
 * re-renders. It is considered self-managed because all of its data dependencies
 * originate from the store and not from a parent component.
 */
const SubmissionRetries = () => {
  useSubmissionRetries();
  return null;
};

export default SubmissionRetries;
